<div class="row">
  <div class="tab-wrapper planning-module-permissions col-12">
    <div class="d-flex mt-8 mb-16 checkbox-wrapper">
      <app-checkbox
        id="canAccesRunsheetsModule"
        [isChecked]="hasAccessToModule() || isInPrimaryRole"
        [disabled]="isInPrimaryRole"
        (checked)="selectRunsheetsUserRole($event)"
      ></app-checkbox>
      <span>{{ T.settings.employees_departments_org.manage_employee.can_access_run_sheets_module | translate }}</span>
    </div>
  </div>
</div>
